module.exports = __webpack_public_path__ + "img/Moduuli_3_vaikutus_tulokseen.5f2fdf11.png";